// extracted by mini-css-extract-plugin
export default {"containerSize":"blocks_container-size_containerSize"};